import { PageProps } from 'gatsby';
import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { TermsOfUse } from '../features/terms-of-use/terms-of-use';

const IndexPage:React.FC<PageProps> =({location})=>{
  return (
    <Layout hideEmail>
      <SEO
        location={location}
        keywords={[
          `habfit`,
          `terms of use`,
          `use service`,
          `platform registration`,
          `billing and payment`,
          `subscription`,
          `client`,
          `trainer`,
          `liability`,
        ]}
        title="Terms of use"
      />
      <TermsOfUse />
    </Layout>
  );
}

export default IndexPage;
